/**
 * "Back to the landing page" key, pinned top-left over the sign-in screen
 * (2026-10-13). User: *"From the login window add a button in the top-left
 * corner to return to the landing page."*
 *
 * The login screen itself is template code (`core/auth/login-screen.ts`), so
 * this is laid over it from the game side instead of edited into it.
 *
 * `/` is not an SPA route: the static server (and the `landing` Vite plugin
 * in dev) serves the marketing page there. main.ts intercepts same-origin
 * link clicks and would route `/` back to `/login`, so the link carries
 * `target="_self"` — its click handler skips any link with a target, and the
 * browser does a real page load.
 *
 * Under `sm` it is the chevron alone (44x44): with the word it reached into
 * the Tallow logo above the card on a 375px phone.
 */
import { t } from '../i18n/i18n';

export const LANDING_HREF = '/';

export function backToLandingMarkup(): string {
  return `
    <a id="back-to-landing" href="${LANDING_HREF}" target="_self"
      class="btn btn-quiet fixed z-20 gap-2 text-sm no-underline min-w-11 max-sm:px-0 max-sm:justify-center"
      style="top: max(1rem, env(safe-area-inset-top)); left: max(1rem, env(safe-area-inset-left));"
      aria-label="${t('Back to the Tallow home page')}">
      <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      <span class="max-sm:sr-only">${t('Home')}</span>
    </a>`;
}

/** Adds the key to `root` and returns its teardown. */
export function mountBackToLanding(root: HTMLElement): () => void {
  root.insertAdjacentHTML('beforeend', backToLandingMarkup());
  const link = root.querySelector('#back-to-landing');
  return () => link?.remove();
}
